import LoginForm from '../../components/forms/login';

const LoginPage = () => {
  return (
    <div className="login-screen">
      <LoginForm />
    </div>
  );
};

export default LoginPage;